import React, { createContext, useContext, useEffect, useState } from "react";
import { isTokenValid } from "../utils/apiInterceptor";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const server = process.env.REACT_APP_API_ROUTE;

  const [user, setUser] = useState(null);
  const [sucursal, setSucursal] = useState(null);
  const [userTickets, setUserTickets] = useState(null);

  const [userLoading, setUserLoading] = useState(true);

  // ✅ CAMBIO: función para cargar user + userTickets (reutilizable)
  const fetchUserAndTickets = async (username) => {
    const url = `${server}/MgUsuarios/${encodeURIComponent(username.toUpperCase())}`;
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch user data");
    }

    const userData = await response.json();
    setUser(userData);

    // ✅ CAMBIO: NO romper sesión si tickets no aplica o viene null
    // Si codUsuarioTickets es null/undefined/0/"" no llamamos /tbl_login/null
    if (!userData?.codUsuarioTickets) {
      setUserTickets(null);
      return;
    }

    // ✅ CAMBIO: Tickets solo si el usuario tiene codUsuarioTickets
    const loginTicketsRes = await fetch(`${server}/tickets/tbl_login/${userData.codUsuarioTickets}`);

    if (!loginTicketsRes.ok) {
      // ✅ CAMBIO: No tirar error, solo no cargar tickets
      console.warn(
        "No se pudo cargar ticket login para codUsuarioTickets:",
        userData.codUsuarioTickets,
        "status:",
        loginTicketsRes.status
      );
      setUserTickets(null);
      return;
    }

    const loginTicketsData = await loginTicketsRes.json();
    const idPersonal = loginTicketsData?.id_personal;

    if (!idPersonal) {
      console.warn("Tickets: no vino id_personal");
      setUserTickets(null);
      return;
    }

    const personalRes = await fetch(`${server}/tickets/tbl_personal/${idPersonal}`);
    if (!personalRes.ok) {
      console.warn("No se pudo cargar personal tickets. idPersonal:", idPersonal);
      setUserTickets(null);
      return;
    }

    const personalData = await personalRes.json();

    setUserTickets({
      idPersonal,
      ...loginTicketsData,
      ...personalData,
    });
  };

  // ✅ rehidratar en F5
  useEffect(() => {
    const bootstrap = async () => {
      try {
        const username = localStorage.getItem("username");
        if (isTokenValid() && username) {
          await fetchUserAndTickets(username);
        } else {
          // ✅ CAMBIO: Si token inválido, asegurar que user sea null
          setUser(null);
          setUserTickets(null);
        }
      } catch (e) {
        console.error("Rehidratación user falló:", e);
        setUser(null);
        setUserTickets(null);
      } finally {
        setUserLoading(false);
      }
    };

    // ✅ CAMBIO: Escuchar evento de logout para limpiar estado
    const handleLogout = () => {
      setUser(null);
      setUserTickets(null);
      setSucursal(null);
      localStorage.removeItem("username");
    };

    window.addEventListener("auth:logout", handleLogout);
    bootstrap();

    return () => {
      window.removeEventListener("auth:logout", handleLogout);
    };
  }, []);

  const login = async (username) => {
    setUserLoading(true);
    try {
      localStorage.setItem("username", username);
      await fetchUserAndTickets(username);
    } finally {
      setUserLoading(false);
    }
  };

  const sucursalSelccionada = async (idSucursal) => {
    setSucursal(idSucursal);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        userTickets,
        sucursal,
        setUser,
        setUserTickets,
        login,
        userLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);